import { customElement, bindable, useView, bindingMode, autoinject, containerless, PLATFORM } from 'aurelia-framework';
import { InputBase } from '../inputBase';

@customElement('input-text')
@useView(PLATFORM.moduleName('./control.html'))
@autoinject()
export class InputText extends InputBase<string> {
    @bindable placeholder: string;
    @bindable hideLabel: boolean;
}
